/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import SearchableContent from "../../Layout/SearchableContent";
import {
  CreateProductInput,
  PaginationProduct,
  Product,
  useFilterProductsLazyQuery,
} from "../../generated/graphql";
import useDebounce from "../../hooks/useDebounce";
import useInputSearch from "../../hooks/useInputSearch";
import { useAppDispatch, useAppSelector } from "../../hooks/usereduxHooks";
import { ProductActionSuccess } from "../../store/actionCreator/product.creator";
import SearchPlaces from "../../utils/SearchPlaces";
import {
  HierarchyItem,
  formattedNum,
  limitAllItem,
} from "../../utils/constant";
import { selectOptionsForItems } from "../itemStock/ItemStock";
import useTextChange from "../../hooks/useTextChange";

export interface HeadingKeyType {
  [key: string]: {
    align: "left" | "right" | "inherit" | "center" | "justify" | undefined;
    id?: string;
  };
}

const ProductTableHeading: HeadingKeyType = {
  "Item Code": { align: "left" },
  "Item Name": { align: "left" },
  "Initial Pcs/bundle": { align: "right" },
  "Initial Meter/Suits": { align: "right" },
  "Pcs/bundle": { align: "right" },
  "Meter/Suits": { align: "right" },
  Rate: { align: "right" },

  Amount: { align: "right" },
};

const ProductTableHeadingOnSelect: HeadingKeyType = {
  "Item Code": { align: "left" },
  "Item Name": { align: "left" },
  "Pcs/bundle": { align: "right" },
  "Meter/Suits": { align: "right" },
  Rate: { align: "right" },
};

export function ItemSetup({
  onSelectProduct,
  setRenderKey,
  setItemData,
  sortKey,
}: {
  onSelectProduct?: Function;
  setItemData?: Function;
  setRenderKey?: Function;
  sortKey?: string;
  selectProduct?: CreateProductInput | undefined;
}) {
  const [page] = useState(0);
  const [limit] = useState(limitAllItem);
  const dispatch = useAppDispatch();
  const [searchKey, setSearchKey] = useState(sortKey || "name");

  const { products } = useAppSelector((store) => store.items);

  const [search, setSearch] = useState("");
  const [fetchProduct, { loading }] = useFilterProductsLazyQuery({
    variables: {
      findMatchProductInput: {
        page,
        limit,
        name: search ? search?.trim() : "",
        searchKey: searchKey,
      },
    },
    fetchPolicy: "no-cache",
  });

  // const [products, setProducts] = useState<PaginationProduct | undefined>(
  //   undefined,
  // );

  const fetchItems = async (orderKey?: string) => {
    const { data } = await fetchProduct({
      variables: {
        findMatchProductInput: {
          page: undefined,
          limit,
          name: search ? search?.trim() : "",
          searchKey: orderKey ?? searchKey,
        },
      },
      fetchPolicy: "no-cache",
    });

    dispatch(ProductActionSuccess(data?.filterProducts as PaginationProduct));
  };

  useDebounce(() => fetchItems(), 300, [search, searchKey, page, limit]);

  useEffect(() => {
    fetchItems();
  }, []);

  const navigate = useNavigate();

  const filterSorting = (parameter: number) => {
    try {
      const searchPerameter = selectOptionsForItems[parameter];
      if (searchPerameter) {
        setSearchKey(searchPerameter.value);
        fetchItems(searchPerameter.value);
        toast.loading(`Sorting by ${searchPerameter.name}, Please wait...`, {
          duration: 2000,
        });
      }
    } catch (err) {}
  };

  useInputSearch({ filterSorting });

  useTextChange();

  return (
    <SearchableContent className={searchKey}>
      <Grid item xs={12} md={12} sm={12}>
        {!onSelectProduct && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent={"space-between"}
          >
            <Box
              display="flex"
              alignItems="flex-start"
              flexDirection={"column"}
              justifyContent={"flex-start"}
              marginBottom={{ xs: "20px", md: "0px" }}
            >
              <Typography variant="h3" component="h3" gutterBottom>
                Item List
              </Typography>
              <Typography variant="subtitle2">
                All items, You can manage item.
              </Typography>
            </Box>
          </Box>
        )}
        <SearchPlaces
          md={12}
          hideSearch={false}
          FieldName="Search item name, code..."
          selectOptions={selectOptionsForItems}
          setSearchKey={setSearchKey}
          searchKey={searchKey}
          search={search}
          setSearch={setSearch}
        />

        <Box
          sx={{
            overflowX: "auto",
            position: "relative",
            width: "100%",
            paddingBottom: onSelectProduct ? "20px" : 0,
          }}
        >
          {loading && (
            <div className="loading-overlay">
              <CircularProgress />
            </div>
          )}
          <TableContainer>
            <Table size={onSelectProduct ? "small" : "medium"} sx={{ minWidth: onSelectProduct ? 480 : 650 }}>
              <TableHead>
                <TableRow>
                  {!onSelectProduct ? (
                    <>
                      {Object.keys(ProductTableHeading).map((heading) => {
                        return (
                          <TableCell
                            align={ProductTableHeading[heading].align}
                            key={heading}
                          >
                            {heading}
                          </TableCell>
                        );
                      })}
                    </>
                  ) : (
                    <>
                      {" "}
                      {Object.keys(ProductTableHeadingOnSelect).map(
                        (heading) => {
                          return (
                            <TableCell
                              align={ProductTableHeading[heading].align}
                              key={heading}
                            >
                              {heading}
                            </TableCell>
                          );
                        },
                      )}
                    </>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {products?.items?.map((item: Product) => {
                  // totalOfAll += item.amount;
                  // console.log(totalOfAll);
                  return (
                    <TableRow
                      onClick={() => {
                        if (onSelectProduct) {
                          onSelectProduct(item);
                        } else {
                          navigate(`/items/add-item/${item.itemCode}`);
                          setRenderKey &&
                            setRenderKey(HierarchyItem["Item Setup"].title);
                        }
                      }}
                      sx={{ cursor: "pointer" }}
                      key={item.id}
                    >
                      <TableCell
                        style={{ textTransform: "uppercase" }}
                        align="left"
                      >
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          gutterBottom
                          noWrap
                          className="itemCode"
                        >
                          {item.itemCode}
                        </Typography>
                      </TableCell>
                      <TableCell
                        style={{ textTransform: "uppercase" }}
                        align="left"
                      >
                        <Typography noWrap>
                          <Typography
                            variant="body1"
                            fontWeight="bold"
                            color="text.primary"
                            gutterBottom
                            noWrap
                            className="name"
                          >
                            {item.name}
                          </Typography>
                        </Typography>
                      </TableCell>

                      {!onSelectProduct ? (
                        <>
                          <TableCell align="right">
                            <Typography
                              variant="body1"
                              fontWeight="bold"
                              color="text.primary"
                              gutterBottom
                              noWrap
                            >
                              {item.sumUpPcsOrBundleBalance!.toFixed(2)}
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography
                              variant="body1"
                              fontWeight="bold"
                              color="text.primary"
                              gutterBottom
                              noWrap
                            >
                              {item.sumUpMeterOrSuitBalance!.toFixed(2)}
                            </Typography>
                          </TableCell>
                        </>
                      ) : (
                        <></>
                      )}

                      <TableCell align="right">
                        <Typography>
                          <Typography
                            variant="body1"
                            fontWeight="bold"
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {item.pcsOrBundle!.toFixed(2)}
                          </Typography>
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.meterOrSuit!.toFixed(2)}
                        </Typography>
                      </TableCell>

                      <TableCell align="right">
                        <Typography
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {item.unitPurchasePrice.toFixed(2)}{" "}
                        </Typography>
                      </TableCell>

                      {!onSelectProduct ? (
                        <>
                          <TableCell align="right">
                            <Typography
                              variant="body1"
                              fontWeight="bold"
                              color="text.primary"
                              gutterBottom
                              noWrap
                            >
                              {formattedNum(
                                item.unitPurchasePrice * item.meterOrSuit!,
                              )}
                            </Typography>
                          </TableCell>
                        </>
                      ) : (
                        <></>
                      )}
                    </TableRow>
                  );
                })}
                {/* {products?.amount && lockOpen ? (
                <TableRow sx={{ cursor: "pointer" }}>
                  <TableCell
                    style={{ textTransform: "uppercase" }}
                    align="left"
                  ></TableCell>
                  <TableCell
                    style={{ textTransform: "uppercase" }}
                    align="left"
                  >
                    <Typography noWrap></Typography>
                  </TableCell>
                  <TableCell
                    style={{ textTransform: "uppercase" }}
                    align="left"
                  >
                    <Typography noWrap></Typography>
                  </TableCell>
                  <TableCell
                    style={{ textTransform: "uppercase" }}
                    align="left"
                  >
                    <Typography noWrap></Typography>
                  </TableCell>

                  <TableCell align="right">
                    <Typography>total</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>{products.amount}</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                <></>
              )} */}
              </TableBody>
            </Table>
          </TableContainer>
          {/* <Box p={2}>
          <TablePagination
            component="div"
            count={-1}
            onPageChange={(e, number) => {
              setPage(number);
            }}
            page={page}
            onRowsPerPageChange={(e) => setLimit(Number(e.target.value))}
            rowsPerPage={limit}
            rowsPerPageOptions={[15, 30, 50, 100]}
          />
        </Box> */}
        </Box>
      </Grid>
    </SearchableContent>
  );
}
